import React from "react";
import { inject, observer } from "mobx-react";
import { Popup } from "../../sharedComponents/popup/popup";
import { ClientStore } from "../../../stores/clientStore";
import TextInput from "../../sharedComponents/textInput/textInput";
import { CapitalizationType } from "../../../helpers/formatter";
import "./clientEndsPopup.scss";

interface ClientEndsPopupProps {
  isOpen: boolean;
  clientStore?: ClientStore;
  onClose: () => void;
  onAction: () => void;
}

@inject("clientStore", "uiFlagsStore")
@observer
export default class ClientEndsPopup extends React.Component<ClientEndsPopupProps> {
  public render() {
    return (
      <div className="popup">
        <Popup
          open={this.props.isOpen}
          className="client-ends-popup"
          dialogContent={
            this.renderContent()
          }
          displayCancel={true}
          cancelClassName="cancel-button"
          cancelText="Anuluj"
          cancel={() => this.cancel()}
          displayAction={true}
          actionText="Wyślij"
          action={() => this.action()}
        />
      </div>
    );
  }

  private renderContent() {
    return (
      <>
        <p className="label">
          Adres e-mail na który ma zostać wysłany link do dokończenia procesu zakupu
        </p>
        <TextInput
          validatedValue={this.props.clientStore!.emailForClientEnds}
          required={true}
          getHelperText={this.getHelperValue.bind(this)}
          capitalize={CapitalizationType.standard}
        />
      </>
    );
  }

  private cancel() {
    this.props.onClose();
  }

  private action() {
    if (!this.props.clientStore!.emailForClientEnds.errorMessage) {
      this.props.onAction();
    }
  }

  private getHelperValue() {
    const errorMessage = this.props.clientStore!.emailForClientEnds.errorMessage;
    return errorMessage ? errorMessage : undefined;
  }
}
